import { swiperQuienesSomos, swiperNuestrosValores, swiperSocios, swiperSociosAvatares, swiperNuestrasVentajas, swiperGrupoEdisur } from '../functions/swiperInit.js';
import { counterJS } from '../functions/counter.js';
import { playerPlaceholder } from '../functions/player-placeholder.js';


document.addEventListener("DOMContentLoaded", () => {

    playerPlaceholder();
    counterJS();
    swiperQuienesSomos();
    swiperNuestrosValores();
    swiperNuestrasVentajas();
    swiperSociosAvatares;
    swiperSocios;
    swiperGrupoEdisur();

});
